import { defHttp } from '@/utils/axios/index'
import type { Response } from '#/axios'
import {
  UserListRequest,
  UserListData,
  RoleData,
  Menu,
  MenuData,
  RoleAddRequest,
  UserAddRequest,
  UserEditRequest,
  UserInfo,
  UpdateNomalUserPwdRequest,
  UpdateSelfPwdRequest
} from '../types/userMgr'

enum Api {
  //用户列表
  userList = '/api/edge/user/list',
  //用户新增
  userAdd = '/api/edge/user/add',
  //用户详情
  userDetail = '/api/edge/user/detail',
  //用户删除
  userDelete = '/api/edge/user',
  //用户编辑
  userEdit = '/api/edge/user/edit',
  //角色列表
  roleList = '/api/edge/role/list',
  //用户下拉
  userNameList = '/api/edge/user/userNameList',
  //姓名下拉
  nickNameList = '/api/edge/user/nickNameList',
  //角色详情
  roleDetail = '/api/edge/role/detail',
  //超管修改一般用户密码
  updateNormalUserPwd = '/api/edge/user/resetPwd',
  //修改自己的密码
  updateSelfPwd = '/api/edge/user/updatePwd',
  // 全部角色菜单
  allMenuTree = '/api/edge/menu/treeselect',
  // 查询角色菜单
  roleMenuTree = '/api/edge/menu/roleMenuTreeselect',
  // 新增角色
  addRole = '/api/edge/role/add',
  // 编辑角色
  editRole = '/api/edge/role/edit',
  //角色删除
  deleteRole = '/api/edge/role',
  // 查询角色是否超管
  queryAdmin = '/api/edge/user/isAdmin',
  // 忘记密码-超管验证安全问题
  verifyAnswers = '/api/edge/user/verifyAnswers',
  // 忘记密码-超管通过安全问题重置密码
  recoverPassword = '/api/edge/user/recoverPassword'
}

export const queryUserList = (data: UserListRequest) =>
  defHttp.post<Response<UserListData>>({ url: Api.userList, data })

export const getUserNameList = () => defHttp.get<Response<string[]>>({ url: Api.userNameList })

export const getNickNameList = () => defHttp.get<Response<string[]>>({ url: Api.nickNameList })

export const deleteUser = (userIds: string[]) =>
  defHttp.delete({ url: `${Api.userDelete}/${userIds.join(',')}` })

export const getRoleList = () => defHttp.get<RoleData>({ url: Api.roleList })

export const getMenuTree = () => defHttp.get<Response<Menu[]>>({ url: Api.allMenuTree })

export const roleMenuTree = (roleIds: number[]) =>
  defHttp.get<Response<MenuData>>({ url: `${Api.roleMenuTree}/${roleIds.join(',')}` })

export const addRole = (data: RoleAddRequest) => defHttp.post({ url: Api.addRole, data })

export const roleDetail = (roleId: string) => defHttp.get({ url: `${Api.roleDetail}/${roleId}` })

export const editRole = (data: RoleAddRequest) => defHttp.post({ url: Api.editRole, data })

export const deleteRole = (roleId: number) =>
  defHttp.delete({
    url: `${Api.deleteRole}/${roleId}`
  })

export const addUser = (data: UserAddRequest) => defHttp.post({ url: Api.userAdd, data })

export const editUser = (data: UserEditRequest) => defHttp.post({ url: Api.userEdit, data })

export const getUserDetail = (uid: number | string) =>
  defHttp.get<Response<UserInfo>>({ url: `${Api.userDetail}/${uid}` })

export const updateNormalUserPwd = (data: UpdateNomalUserPwdRequest) =>
  defHttp.post({ url: Api.updateNormalUserPwd, data })

export const updateSelfPwd = (req: UpdateSelfPwdRequest) =>
  defHttp.put({
    url: `${Api.updateSelfPwd}`,
    data: req
  })

export const queryAdmin = (userName: string) =>
  defHttp.get({ url: `${Api.queryAdmin}/${userName}` })

export const verifyAnswers = (data: any) => defHttp.post({ url: Api.verifyAnswers, data })

export const recoverPassword = (data: any) => defHttp.post({ url: Api.recoverPassword, data })

// 大小写都要
export const USER_PWD_REGEX = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[\d\W])[A-Za-z\d\W]{6,12}$/
// 大写或小写
// export const USER_PWD_REGEX = /^(?=.*[A-Za-z])(?=.*[\d\W])[A-Za-z\d\W]{6,12}$/

export const validatePwd = (str: string) => {
  const hasUpperCase = /[A-Z]/.test(str)
  const hasLowerCase = /[a-z]/.test(str)
  const hasDigit = /\d/.test(str)
  const hasSymbol = /[!@#$%^&*(),.?":{}|<>]/.test(str)

  const typesCount = [hasUpperCase, hasLowerCase, hasDigit, hasSymbol].filter(Boolean).length

  return typesCount >= 3 && str.length >= 6 && str.length <= 12
}
